import { InputMask } from "primereact/inputmask";
import { InputTextarea } from "primereact/inputtextarea";
import { SelectButton } from "primereact/selectbutton";
import { Dropdown } from "primereact/dropdown";
import { useEffect, useState } from "react";
import CardSeplag from "../CardSeplag";
import Rotulo from "../RotuloSeplag";
import { InputText } from "primereact/inputtext";
import { buscarPeloCodigo } from "../../service/Rag/AvaliacaoAcao";
import { Button } from "primereact/button";
import { downloadArquivoRAG } from "../../service/Rag/AvaliacaoAcao";

const QuestionarioSeplag = (props) => {
  const [valorSelButton, setValorSelButton] = useState([]);
  const [qtdMaxCaracteres, setQtdMaxCaracteres] = useState(props.qtdMaxCaracteres ? props.qtdMaxCaracteres : null);
  const [v_idenArquivoQuest, setIdenArquivoQuest] = useState(null);
  const [v_nomeArquivoQuest, setNomeArquivoQuest] = useState(""); // Estado para armazenar o nome do arquivo

  useEffect(() => {
    var posicao = 0;
    var arraytemp = [];

    Array.from(props.campos, function mapFn(element) {
      arraytemp[posicao] = element.data;
      posicao++;
      setValorSelButton(arraytemp);
    });

    let selectButton = document.querySelectorAll(".div-opcao-unica > div");
    selectButton.forEach((element) => {
      const numChildren = element.children.length;
      const numFr = 100 / numChildren;

      element.style.display = "grid";
      element.style.gridTemplateColumns = `repeat(${numChildren},${numFr}fr)`;
    });

    let selectButtonItens = document.querySelectorAll(".div-opcao-unica > div > div");
    selectButtonItens.forEach((element) => {
      element.style.width = "100%";
      element.style.padding = "0.3em 1em";
      element.style.display = "flex";
      element.style.alignItems = "center";
      element.style.justifyContent = "center";
    });
  }, []); 

  //Busca o nome do arquivo pelo Id do Banco
  const buscarNomeArquivoBanco = async () => {
    if (props.idArquivoQuestinario) {
      //console.log("IdenArquivo",props.idArquivoQuestinario)
      const respostaAux = await buscarPeloCodigo(props.idArquivoQuestinario);
      //Concatena o codigo da Unidade e Acao ao nome do arquivo
      setNomeArquivoQuest(props.codUnidadeAcao.unidade+"_"+props.codUnidadeAcao.acao+"_"+respostaAux.descArquivo); // Armazena o nome no estado      
      // console.log("NomeArquivo>>>",respostaAux.descArquivo)
      setIdenArquivoQuest(props.idArquivoQuestinario);
    }
  };

  useEffect(() => {
    buscarNomeArquivoBanco();
  }, [props.idArquivoQuestinario]);

  function mudarValor(pos, value) {
    const newCampos = [];
    var arraytemp = [];

    for (var i = 0; i < valorSelButton.length; i++) {
      if (i === pos) {
        arraytemp.push(value);
      } else {
        arraytemp[i] = valorSelButton[i];
      }
    }

    for (let count = 0; count < arraytemp.length; count++) {
      newCampos.push({ ...props.campos[count], data: arraytemp[count] });
    }
    props.setCampos(newCampos);
    setValorSelButton(arraytemp);
  }

  function setarCampoText(item, chave, texto) {
    item.data = texto;

    let v_campos = props.campos.map((i) => {
      return i.rowId !== item.rowId ? i : item;
    });

    props.setCampos(v_campos);
  }

  const downloadRAG = (v_idenArquivoQuest) => {
    //console.log("downloadRAG",v_idenArquivoQuest,v_nomeArquivoQuest)
    downloadArquivoRAG(v_idenArquivoQuest).then((res) => {
      // Extraia a parte base64 da resposta
      const base64Data = res.data.split(",")[1];

      // Converta a string base64 para um array de bytes
      const byteCharacters = atob(base64Data);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);

      // Crie um Blob com o array de bytes
      const blob = new Blob([byteArray], { type: "application/pdf" });

      // Crie uma URL temporária para o Blob e acione o download
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;      
      // a.download = `arquivo_${v_nomeArquivoQuest}`; // Define o nome do arquivo      
      a.download = v_nomeArquivoQuest; // Define o nome do arquivo
      a.click();
      URL.revokeObjectURL(url); // Revoga a URL após o download
    });
  };

  //console.log("NomePeloQuestionarioPontoTres: " + v_nomeArquivoQuest + " , " + v_idenArquivoQuest);
  const formatarMilhar = (num) => {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  };
  return (
    <>
      <CardSeplag title={props.titulo} cols={props.cols}>
        {props.campos.map((item, chave) => {
          return (
            props.condicao(item, props.campos) && (
              <Rotulo
                nome={item.label}
                key={item.id}
                cols={item.cols}
                obrigatorio={item.flagObrigatorio === "S" && !props.isDisabled ? true : false}
              >
                {item.type === "TEXTO" && (
                  <>
                    <InputTextarea
                      rows={10}
                      maxLength={qtdMaxCaracteres}
                      cols="120"
                      style={{ width: "100%" }}
                      value={item.data}
                      disabled={props.isDisabled}
                      onChange={(e) => setarCampoText(item, chave, e.target.value)} /*onChange={ setCampos }*/
                      autoResize
                    />
                    {props.IsMaximoCaracteres && (
                      <span className="contador-caracteres">
                        {formatarMilhar(qtdMaxCaracteres - (item.data ? item.data.length : 0))} caracteres restantes
                      </span>
                    )}
                    <br />
                    <br />
                  </>
                )}
                {item.type == "OPCAOUNICA" && (
                  <>
                    <div className="div-opcao-unica">
                      <SelectButton
                        value={item.data}
                        options={item.options}
                        optionValue="name"
                        optionLabel="code"
                        disabled={props.isDisabled}
                        /*onChange={(e) => mudarValor(chave, e.value)}*/
                        onChange={(e) => setarCampoText(item, chave, e.target.value)} /*onChange={ setCampos }*/
                      />
                    </div>
                    <br />
                    <br />
                  </>
                )}
                {item.type == "DATA" && (
                  <InputMask mask="99/99/9999" slotChar="__/__/____" placeholder="__/__/____" value={item.data} />
                )}
                {item.type == "LISTA" && (
                  <>
                    <Dropdown
                      id="idcombobox"
                      placeholder="Selecione uma alternativa"
                      emptyMessage="Dados não encontrados"
                      options={item.options}
                      optionValue="name"
                      optionLabel="code"
                      value={item.data}
                      showClear
                      onChange={(e) => setarCampoText(item, chave, e.target.value)}
                      disabled={props.isDisabled}
                      style={{ minWidth: "220px" }}
                    />
                    {item.data === "Sim" && ( //Controle para mostrar os campos somente quando for opcao Sim
                      <>
                        <br />
                        <br />
                        {!props.isDisabled && (
                          <>
                            <label htmlFor="selecao-arquivo-quest" className="label">
                              Selecionar um arquivo &#187;
                            </label>
                            <input
                              id="selecao-arquivo-quest"
                              type="file"
                              onChange={props.onUpload}
                              key="arquivo2"
                              accept="application/pdf"
                            />
                            <br />
                            <br />
                            <label>Arquivo .pdf (tamanho máximo de 15Mb) </label>
                          </>
                        )}
                        <div className="" style={{ paddingTop: "1rem" }}>
                          {props.arquivo && (
                            <Rotulo nome="Nome do arquivo adicionado">
                              <InputText value={props.arquivo.name || props.arquivo.descArquivo} disabled />
                            </Rotulo>
                          )}
                        </div>
                        {item.idenArquivo > 0 && (
                          <>
                            <Button
                              icon="pi pi-download"
                              label={v_nomeArquivoQuest}
                              className="p-button-text"
                              iconPos="right"
                              onClick={() => downloadRAG(v_idenArquivoQuest)}
                            />
                          </>
                        )}
                      </>
                    )}
                  </>
                )}
              </Rotulo>
            )
          );
        })}
      </CardSeplag>
    </>
  );
};

export default QuestionarioSeplag;
